import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import AbilitiesService from 'donor-elf-web/services/abilities';

export default class MapMyContactsRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare abilities: AbilitiesService;

  beforeModel(transition: any) {
    if (this.abilities.noAbility('view_contact_name')) {
      transition.abort();
    }
    this.navbarSettings.title = 'Map My Contacts';
  }
}
